var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinaryFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__x2C_5",
    enableBackground: "new 0 0 36 36",
    height: 512,
    viewBox: "0 0 36 36",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.377 31.833c6.917 0 11.667 3.583 15 3.583s10.333-1.916 10.333-17.249-9.417-17.584-13.083-17.584c-17.167 0-24.5 31.25-12.25 31.25z",
    fill: "#f3f3f1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4afc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.678 5.319h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 4.37 23.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.612 1.254h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 6.054 19.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.178 1.931h2v1h-2z",
    transform: "matrix(.707 -.707 .707 .707 7.12 22.051)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.25 29.25h-12.5c-1.105 0-2-.895-2-2v-18.5c0-1.105.895-2 2-2h12.5c1.105 0 2 .895 2 2v18.5c0 1.105-.895 2-2 2z",
    fill: "#efefef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 27.25v-18.5c0-1.105.895-2 2-2h-2.25c-1.105 0-2 .895-2 2v18.5c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z",
    fill: "#d5dbe1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.25 30h-12.5c-1.517 0-2.75-1.233-2.75-2.75v-18.5c0-1.517 1.233-2.75 2.75-2.75h12.5c1.517 0 2.75 1.233 2.75 2.75v18.5c0 1.517-1.233 2.75-2.75 2.75zm-12.5-22.5c-.689 0-1.25.561-1.25 1.25v18.5c0 .689.561 1.25 1.25 1.25h12.5c.689 0 1.25-.561 1.25-1.25v-18.5c0-.689-.561-1.25-1.25-1.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13.75 17c-.414 0-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75v4.5c0 .414-.336.75-.75.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22.25 17c-.414 0-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75v4.5c0 .414-.336.75-.75.75z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22.25 25c-.414 0-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75v4.5c0 .414-.336.75-.75.75z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19.25 25c-.414 0-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75v4.5c0 .414-.336.75-.75.75z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 17h-1c-.965 0-1.75-.785-1.75-1.75v-2.5c0-.965.785-1.75 1.75-1.75h1c.965 0 1.75.785 1.75 1.75v2.5c0 .965-.785 1.75-1.75 1.75zm-1-4.5c-.138 0-.25.112-.25.25v2.5c0 .138.112.25.25.25h1c.138 0 .25-.112.25-.25v-2.5c0-.138-.112-.25-.25-.25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m15.75 25h-1c-.965 0-1.75-.785-1.75-1.75v-2.5c0-.965.785-1.75 1.75-1.75h1c.965 0 1.75.785 1.75 1.75v2.5c0 .965-.785 1.75-1.75 1.75zm-1-4.5c-.138 0-.25.112-.25.25v2.5c0 .138.112.25.25.25h1c.138 0 .25-.112.25-.25v-2.5c0-.138-.112-.25-.25-.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaryFile);
export default __webpack_public_path__ + "static/media/binary-file.3f7fe612427e9ca1c534a02739c7a142.svg";
export { ForwardRef as ReactComponent };